import React, { useEffect, useMemo, useState } from "react";
import Cards from "../../cards/Cards";
import PerformaceVendas from "../../cards/PerformaceVendas";
import ValorCard from "../../cards/ValorCard";
import Sidebar from "../../menu/Sidebar";
import Topbar from "../../menu/Topbar";
import Api from "../../Services/Api";
import ExtratoFilters from "../tabelaExtrato/ExtratoFilter";
import TabelaExtrato from "../tabelaExtrato/TabelaExtrato";
import "../historico/Historico.css";

const INITIAL_FILTERS = {
  type: "ALL",
  status: "ALL",
  order: "",
  start: "",
  end: "",
};

const LIMIT = 20;

const ExtratoCompleto = () => {
  const [menuClose, setMenuClose] = useState(false);
  const toggleMenu = () => setMenuClose((prev) => !prev);

  const [extratoDados, setExtratoDados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(false);

  const [filters, setFilters] = useState(INITIAL_FILTERS);

  const params = useMemo(() => {
    const p = {
      type: filters.type,
      status: filters.status,
      order: filters.order?.trim(),
      start: filters.start,
      end: filters.end,
      limit: LIMIT,
      offset,
    };

    Object.keys(p).forEach((k) => {
      if (!p[k] || p[k] === "ALL") delete p[k];
    });

    return p;
  }, [filters, offset]);

  const fetchData = async ({ reset = false, forceParams = null } = {}) => {
    try {
      setLoading(true);

      const response = await Api.get("/ledger-entries/me/history", {
        params: forceParams || params,
      });
      const payload = response.data?.data ?? response.data ?? [];
      const list = Array.isArray(payload) ? payload : [];

      const pagination = response.data?.pagination;
      const more =
        typeof pagination?.hasMore === "boolean"
          ? pagination.hasMore
          : list.length === LIMIT;

      setHasMore(more);

      if (reset) setExtratoDados(list);
      else setExtratoDados((prev) => [...prev, ...list]);
    } catch (err) {
      console.error("Erro ao carregar extrato completo:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData({ reset: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleApplyFilters = () => {
    setOffset(0);
    const forceParams = {
      ...(params || {}),
      offset: 0,
    };
    fetchData({ reset: true, forceParams });
  };

  const handleClearFilters = () => {
    const forceParams = { limit: LIMIT, offset: 0 };
    setFilters(INITIAL_FILTERS);
    setOffset(0);
    fetchData({ reset: true, forceParams });
  };

  const handleLoadMore = () => {
    if (loading || !hasMore) return;
    setOffset((prev) => prev + LIMIT);
  };

  useEffect(() => {
    if (offset === 0) return;
    fetchData({ reset: false });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset]);

  return (
    <div className="app-container">
      <Sidebar close={menuClose} extratoActive="active" />

      <main className="main-content">
        <Topbar page="Extrato" onToggleMenu={toggleMenu} />

        <Cards>
          <ValorCard />
          <PerformaceVendas />
        </Cards>

        <ExtratoFilters
          filters={filters}
          loading={loading}
          onChange={(partial) => setFilters((prev) => ({ ...prev, ...partial }))}
          onApply={handleApplyFilters}
          onClear={handleClearFilters}
        />

        <TabelaExtrato itensLista={extratoDados} loading={loading}>
          <div>Extrato completo (todo o historico de lancamentos).</div>
        </TabelaExtrato>

        <div style={{ display: "flex", justifyContent: "center", margin: "16px 0" }}>
          {hasMore && (
            <button className="btn-primary" onClick={handleLoadMore} disabled={loading}>
              {loading ? "Carregando..." : "Carregar mais"}
            </button>
          )}
        </div>
      </main>
    </div>
  );
};

export default ExtratoCompleto;
